import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { AuthService } from '../service/auth.service';
import { AppConstants } from '../AppConstants';

@Injectable({ providedIn: 'root' })
export class AdminDashboardGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate() {
    this.auth.syncUserContext();
    const raw = this.auth.getStoredItem(AppConstants.SESSION_STORAGE_EXTERNAL_USER_CONTEXT)
      || this.auth.getStoredItem(AppConstants.SESSION_STORAGE_CURRENT_USER_CONTEXT);
    const role = raw ? Number(JSON.parse(raw).roleId) : 0;
    return [1, 2].includes(role) || this.router.parseUrl('/landing-page/transactions');
  }
}
